import { render, staticRenderFns } from "./IndustryDashboard.vue?vue&type=template&id=e2d6ff64&scoped=true"
import script from "./IndustryDashboard.vue?vue&type=script&lang=js"
export * from "./IndustryDashboard.vue?vue&type=script&lang=js"
import style0 from "./IndustryDashboard.vue?vue&type=style&index=0&id=e2d6ff64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d6ff64",
  null
  
)

export default component.exports